import React from "react"
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ReviewsIcon from "../../images/reviews.inline.svg";
import Slider from "react-slick";

class ReviewsExtended extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: [],
      isLoading: true,
    };
  }

  fetchReviews() {
    axios.get(`https://api.reviews.co.uk/merchant/reviews?per_page=10&order=desc&store=adtrak-llp`)
    
    .then(res => 
      this.setState({
        reviews: res.data.reviews,
        stats: res.data.stats,
        isLoading: false
      })
    )
    .catch((err) => {
      console.log(err + ': Error accessing Reviews API');
    });
  }

  componentDidMount() {
    this.fetchReviews();
  }
  
  render() {
    const settings = {
      autoplay: true,
      navigation: false,
      infinite: true,
      slidesToShow: 3,
      speed: 750,
      slidesToScroll: 3,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <>
        {!this.state.isLoading ? (
          <div className="flex flex-wrap">
            <div className="w-full lg:flex-1 pb-8 lg:pb-0">
              <a href="https://www.reviews.co.uk/company-reviews/store/adtrak-llp" target="_blank" rel="noopener noreferrer" className="inline-block text-center no-underline hover:opacity-75 focus:opacity-75">
                <div>
                  <span className="text-base text-sm">Rated <strong>{this.state.stats.average_rating}</strong></span>
                </div>

                <div>
                  {[...Array(Math.round(this.state.stats.average_rating))].map((e, i) => (
                    <FontAwesomeIcon key={i} className="text-primary text-lg mr-1" icon="star" />
                  ))}
                </div>

                <div className="mb-1">
                  <span className="text-base text-sm">Read our <strong>{this.state.stats.total_reviews}</strong> reviews</span>
                </div>
                
                <div className="w-40">
                  <ReviewsIcon />
                </div>

                {/* { JSON.stringify(this.state.reviews) } */}
              </a>
            </div>
            
            <div className="w-full lg:w-10/12">
              <div className="lg:pl-8">
                <Slider {...settings}>
                  {this.state.reviews.map(({ comments }, index) => {
                    return(
                      <div key={index} className="pr-8">
                        <span className="block mb-4">{ comments.split(" ").splice(0,25).join(" ") }</span>
                        <div>
                          {[...Array(Math.round(this.state.stats.average_rating))].map((e, i) => (
                            <FontAwesomeIcon key={i} className="text-primary text-lg mr-1" icon="star" />
                          ))}
                        </div>
                      </div>
                    )
                  })}
                </Slider>
              </div>
            </div>
          </div>
        ) : (
          <p>Loading Reviews&hellip;</p>
        )}
      </>
    );
  }
}

export default ReviewsExtended;